<div
  class="login-form__card"
  (keyup.enter)="signIn$.next()">
  <h1 class="login-form__card-title text-center">Войти в аккаунт</h1>
  <div class="space-y-4 md:space-y-6">
    <div>
      <tui-textfield
        tuiTextfieldSize="l"
        [tuiTextfieldCleaner]="false">
        <label tuiLabel>Логин</label>
        <input
          tuiTextfield
          [formControl]="form.controls.login" />
      </tui-textfield>
    </div>
    <div>
      <tui-textfield
        tuiTextfieldSize="l"
        [tuiTextfieldCleaner]="false">
        <label tuiLabel>Пароль</label>
        <input
          tuiTextfield
          type="password"
          [formControl]="form.controls.password" />
        <tui-icon tuiPassword />
      </tui-textfield>
    </div>

    <div class="my-3">
      <button
        appearance="accent"
        size="l"
        tuiButton
        class="w-full"
        [disabled]="form.invalid"
        [loading]="(loading$ | async)!"
        (click)="signIn$.next()">
        Войти
      </button>
    </div>
  </div>
</div>
